/* eslint-disable global-require */
import React from 'react';

export const slidesConfig = [
    {
        id: '4741',
        isLineBreakStrict: true,
        title: '',
        titleXS: <>
            Паста с курицей, беконом
            <br />
            и творожным сыром Hochland
        </>,
        titleS: <>
            Паста с курицей, беконом
            и творожным сыром Hochland
        </>,
        titleM: <>
            Паста с курицей, беконом
            и творожным сыром Hochland
        </>,
        titleL: <>
            Паста с курицей, беконом
            и творожным сыром Hochland
        </>,
        src: 'https://rutube.ru/play/embed/3822687ef4cd9c57010b9eadf5ebc9ab/?p=ZyhM5PKMTlUhlswv2kMWag',
        bg: require('./img/hochland/4741.jpg'),
    },
    {
        id: '4748',
        isLineBreakStrict: true,
        titleXS: <>
            Киш с беконом и
            <br />
            сливочным плавленым сыром Hochland
        </>,
        titleS: <>
            Киш с беконом и
            <br />
            сливочным плавленым сыром Hochland
        </>,
        titleM: <>
            Киш с беконом и
            <br />
            сливочным плавленым сыром Hochland
        </>,
        titleL: <>
            Киш с беконом
            <br />
            и сливочным плавленым сыром Hochland
        </>,
        src: 'https://rutube.ru/play/embed/a325d4bf3f67b254688526062f26f724/?p=f5qldHvAKPVXzzEAtqCheg',
        bg: require('./img/hochland/4748.jpg'),
    },
    {
        id: '4749',
        titleXS: <>
            Конвертики из тортильи
            <br />
            с вялеными томатами и плавленым сыром Hochland
        </>,
        titleS: <>
            Конвертики из тортильи
            <br />
            с вялеными томатами и плавленым сыром Hochland
        </>,
        titleM: <>
            Конвертики
            <br />
            из тортильи с вялеными томатами и плавленым сыром Hochland
        </>,
        titleL: <>
            Конвертики из тортильи с вялеными томатами и плавленым сыром Hochland
        </>,
        isLineBreakStrict: true,
        src: 'https://rutube.ru/play/embed/d78a0fe910870e3b1d016e1d845c9a5a/?p=WhJXqve0SIiTbQ4jpfhGqw',
        bg: require('./img/hochland/4749.jpg'),
    },
    {
        id: '4750',
        title: 'Завтрак Омлет-ролл с травами и творожным сыром Hochland',
        src: 'https://rutube.ru/play/embed/f7386d55c6d30721a0862004cdbe3235/?p=DU59-G0j0aNlxQo3wkenYA',
        bg: require('./img/hochland/4750.jpg'),
    },
    {
        id: '4233',
        src: 'https://www.youtube.com/embed/_Df-tFLw4FU',
        bg: require('./img/romantic/first_video.jpg'),
    },
    {
        id: '4240',
        src: 'https://www.youtube.com/embed/gR1FL_kscxs',
        bg: require('./img/romantic/second_video.jpg'),
    },
    {
        id: '4232',
        src: 'https://www.youtube.com/embed/Z3YLr3aYdfE',
        bg: require('./img/romantic/third_video.jpg'),
    },
    {
        id: '4234',
        src: 'https://www.youtube.com/embed/DAa3MET1qNE',
        bg: require('./img/romantic/fourth_video.jpg'),
    },
    {
        id: '4233',
        title: 'Куриные стрипсы в кляре',
        src: 'https://rutube.ru/play/embed/29dc7eb45551b5d3c98bbe78065a1f14/',
        bg: require('./img/kozel/first.jpg'),
    },
    {
        id: '4240',
        title: 'Бургеры из говядины с соусом барбекю',
        src: 'https://rutube.ru/play/embed/9703212dc4cb1f1348fafc457bae0789/',
        bg: require('./img/kozel/second.jpg'),
    },
    {
        id: '4232',
        title: 'Мясное жаркое',
        src: 'https://rutube.ru/play/embed/938e93ea5911d39ee903da3d17d3ab65/',
        bg: require('./img/kozel/third.jpg'),
    },
    {
        id: '4234',
        title: 'Биркейк с копчёностями',
        src: 'https://rutube.ru/play/embed/2e6cea1d83e9ff32280857d08771bf93/',
        bg: require('./img/kozel/fourth.jpg'),
    },
    {
        id: '4233',
        src: 'https://rutube.ru/play/embed/a80d28edf2e700e323a64f692efdadd9/?p=lj0X58cSVSFais39PjlSBQ',
        bg: require('./img/halloween/first_video_halloween.jpg'),
    },
    {
        id: '4240',
        src: 'https://rutube.ru/play/embed/f538e4cf27ecf0fc7e03697de8c6b867/?p=SJFrm95Y9Mo7K2SalqjSig',
        bg: require('./img/halloween/second_video_halloween.jpg'),
    },
    {
        id: '4232',
        src: 'https://rutube.ru/play/embed/a215ec891acc946548f0162cbd71eb71/?p=kznGw5ttfJYeq81AtD2nHg',
        bg: require('./img/halloween/third_video_halloween.jpg'),
    },
    {
        id: '4234',
        src: 'https://rutube.ru/play/embed/3bfbcdad80e38d2c251f996c9a79548c/?p=jcu7tYHrraBOodDJzod--A',
        bg: require('./img/halloween/fourth_video_halloween.jpg'),
    },
    {
        id: '4233',
        src: 'https://rutube.ru/play/embed/023f99afbb22ea6a39c912a35d0f5b3c/?p=441GR1yJesEOfsH2EB9ZOg',
        bg: require('./img/maxim/first_video_maxim.jpg'),
    },
    {
        id: '4240',
        src: 'https://rutube.ru/play/embed/f538e4cf27ecf0fc7e03697de8c6b867/?p=SJFrm95Y9Mo7K2SalqjSig',
        bg: require('./img/maxim/second_video_maxim.jpg'),
    },
    {
        id: '4232',
        src: 'https://rutube.ru/play/embed/a215ec891acc946548f0162cbd71eb71/?p=kznGw5ttfJYeq81AtD2nHg',
        bg: require('./img/maxim/third_video_maxim.jpg'),
    },
    {
        id: 'pasta',
        src: 'https://rutube.ru/play/embed/023f99afbb22ea6a39c912a35d0f5b3c/?p=441GR1yJesEOfsH2EB9ZOg',
    },
    {
        id: 'spagetti',
        src: 'https://rutube.ru/play/embed/6e87465b4d3f0c59157007f8e8d28bd7/?p=lbq-nTCrLmir6ii3UaBo5g',
    },
    {
        id: 'medallion',
        src: 'https://rutube.ru/play/embed/5aaf6ebb082d40e9c822f3504da11cf0/?p=QC3HVOsKQdwULEawiZPS9w',
    },
    {
        id: 'pasta',
        src: 'https://rutube.ru/play/embed/023f99afbb22ea6a39c912a35d0f5b3c/?p=441GR1yJesEOfsH2EB9ZOg',
    },
    {
        id: 'lasagna',
        src: 'https://rutube.ru/play/embed/f2a2937a29f4891f895f89613b5cb528/?p=ktQBrixACJ4SVuBKmJlz2A',
    },
    {
        id: 'tomyam',
        src: 'https://rutube.ru/play/embed/df77ae2e2c38a347a4464b27bb4a8bc5/?p=pCVpeRNpkhcP21ElSNNKqA',
    },
    {
        id: 'marchgifts',
        src: 'https://rutube.ru/play/embed/b403455afe71eb59ed24e33ad6b3ff17/?p=WYqyJ_j6SMNRSCUntd6P1w',
    },
    // {
    //     id: 'miragoshacook',
    //     src: 'https://rutube.ru/play/embed/62810327018f427e09647be007baec70/?p=rJ5f84BmWpD4vHFB0GtXjw',
    // },
    // {
    //     id: 'miragoshaepisode',
    //     src: 'https://rutube.ru/play/embed/ceeec180ba61c87986223d277d94df8d',
    // },
];
